// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"c466ce23","195":"c5db6ed8","397":"52265758","430":"70878b39","626":"578db2bc","637":"3af602f8","695":"a38147c0"}[chunkId] + ".chunk.js";
};